/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Scope_Always_TeamInputs */



/**
* | output |
* | --- |
* | "This conversation, every time" |
*
* @param {Meeting_Scope_Always_TeamInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_scope_always_team = /** @type {((inputs?: Meeting_Scope_Always_TeamInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Scope_Always_TeamInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dit gesprek, elke keer")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette conversation, à chaque fois")
	return /** @type {LocalizedString} */ ("This conversation, every time")
});